<script setup lang="ts">
import { useDisplay } from 'vuetify';
import { useStudentStore } from '@/stores/student';

const studentStore = useStudentStore();

const { mdAndUp } = useDisplay();
</script>

<template>
    <VCard to="/programmes" class="dashboard-card dashboard-card--programmes d-flex flex-column">
        <VCardTitle>
          <p class="dashboard-card__title d-flex flex-column d-md-block text-center text-md-left text-white">
            <span class="mr-md-4"><VIcon icon="mdi-laptop" :size="mdAndUp ? 36 : 48" /></span>
            <span class="font-museo" :class="`font-${studentStore.fontStyle}`">{{ $t('pages.dashboard.programmes.title')  }}</span>
          </p>
        </VCardTitle>
        <VCardText class="align-content-end text-white">
          <VRow>
            <VCol cols="12" md="7" class="d-none d-md-flex flex-column justify-space-between pt-0">
              <p class="dashboard-card__description pt-6 pb-3">
                {{ $t('pages.dashboard.programmes.description') }}
              </p>
              <VBtn variant="tonal" rounded="xl" class="dashboard-card__view-btn dashboard-card__view-btn--programmes">
                  {{ $t('pages.dashboard.programmes.view_btn') }}
              </VBtn>
            </VCol>
            <VCol cols="12" md="5">
              <VImg class="dashboard-card__image" src="@images/dashboard/programmes.svg" />
            </VCol>
          </VRow>
        </VCardText>
    </VCard>
</template>
